import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref } from 'vue';
import ModalForm from '@astina/paloma-common-ui/src/components/ModalForm.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ArticleParametersForm',
    props: {
        variant: {},
        params: {}
    },
    emits: [
        'cancel',
        'submit'
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const params = props.variant.parameters;
        const form = ref({
            name: 'parameters',
            fields: Object.keys(params).map(name => {
                const param = params[name];
                return {
                    name: param.name,
                    label: param.label,
                    type: param.type,
                    options: param.formOptions
                };
            })
        });
        const values = ref({});
        props.params.forEach(param => {
            values.value[param.name] = param.value;
        });
        function cancel() {
            values.value = {};
            emit('cancel');
        }
        function submit() {
            const params = [];
            form.value.fields.forEach(field => {
                params.push({
                    name: field.name,
                    value: values.value[field.name] || null,
                });
            });
            emit('submit', params);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ModalForm, {
                form: form.value,
                data: values.value,
                title: __props.variant.name,
                "submit-label": _ctx.$t('save'),
                onCancel: cancel,
                onSubmit: submit
            }, null, 8, ["form", "data", "title", "submit-label"]));
        };
    }
});
